import { render, staticRenderFns } from "./people_worth.vue?vue&type=template&id=54acbb30&scoped=true"
import script from "./people_worth.vue?vue&type=script&lang=js"
export * from "./people_worth.vue?vue&type=script&lang=js"
import style0 from "./people_worth.vue?vue&type=style&index=0&id=54acbb30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54acbb30",
  null
  
)

export default component.exports